module.exports = __webpack_public_path__ + "static/media/ARD-IMDG.6d9a7013.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/ARD-IMDG.svg
// module id = 88
// module chunks = 0